/**
 * Created by olga on 11.09.2025
 */

const PersonalBestBotAlgorithm = function (competition, options) {
    this.competition = competition;
    this.options = options;

    this.speedType = options.speedType || PersonalBestBotAlgorithm.SpeedType.PerDay;
    this.started = options.start;
    this.speed = options.speed;
    this.step = options.step;

    this.pseudoRandom = PseudoRandom.GET("PersonalBestBotAlgorithm");
};

PersonalBestBotAlgorithm.prototype.start = function () {
    if (!this.competition.running) {
        return;
    }

    this.process();

    this.runInterval = cleverapps.timeouts.setInterval(() => {
        if (this.competition.running) {
            this.process();
        } else {
            this.stop();
        }
    }, this.intervalTimeout());
};

PersonalBestBotAlgorithm.prototype.stop = function () {
    if (this.runInterval) {
        cleverapps.timeouts.clearInterval(this.runInterval);
        this.runInterval = undefined;
    }
};

PersonalBestBotAlgorithm.prototype.intervalTimeout = function () {
    return cleverapps.parseInterval("5 seconds");
};

PersonalBestBotAlgorithm.prototype.getData = function () {
    return {
        start: this.started,
        speed: this.speed,
        step: this.step
    };
};

PersonalBestBotAlgorithm.prototype.isFinished = function () {
    return this.options.finish > 0 && Date.now() >= this.options.finish;
};

PersonalBestBotAlgorithm.prototype.process = function () {
    const playerAvgSpeed = this.calcUserPerSecondSpeed();
    const processTime = this.isFinished() ? this.options.finish : Date.now();
    const timePassed = Math.max(0, Math.floor((processTime - this.started) / 1000));

    const bots = this.competition.results;

    for (let i = 0; i < bots.length; ++i) {
        const bot = bots[i];

        if (bot.player) {
            continue;
        }

        if (!bot.coef) {
            bot.coef = this.calcBotCoef();
        }

        const amount = Math.floor(timePassed * playerAvgSpeed * bot.coef);
        const step = this.calcUserStep(bot.id);
        const steppedAmount = Math.floor(amount / step) * step;

        this.competition.updatePlayerResult(bot.id, steppedAmount);
    }
    this.competition.save();
};

PersonalBestBotAlgorithm.prototype.calcUserStep = function (id) {
    if (!this.step) {
        this.step = Math.max(
            cleverapps.personalBest.getAvgStep(this.options.avgSpeed) || 1,
            cleverapps.personalBest.getDefaultAvgStep(this.options.avgSpeed) || 1
        );
    }

    this.pseudoRandom.seed(id);
    const p = this.pseudoRandom.nextDouble();
    const deviation = 0.2;
    const deviationFactor = (1 - deviation) + p * deviation * 2;
    const multiple = this.options.stepMultiple || 1;
    return Math.max(multiple, Math.round(this.step * deviationFactor / multiple) * multiple);
};

PersonalBestBotAlgorithm.prototype.calcUserPerSecondSpeed = function () {
    if (this.speedType === PersonalBestBotAlgorithm.SpeedType.PerDay) {
        const speedPerDay = Math.max(
            cleverapps.personalBest.getPerDaySpeed(this.options.avgSpeed) || 0,
            cleverapps.personalBest.getDefaultPerDaySpeed(this.options.avgSpeed) || 0
        );
        if (!this.speed || (this.speed < speedPerDay && !this.isFinished())) {
            this.speed = speedPerDay;
        }

        return this.speed / (24 * 60 * 60);
    }

    if (this.speedType === PersonalBestBotAlgorithm.SpeedType.PerMinute) {
        const speedPerMinute = Math.max(
            cleverapps.personalBest.getPerMinutesSpeed(this.options.avgSpeed) || 0,
            cleverapps.personalBest.getDefaultPerMinuteSpeed(this.options.avgSpeed) || 0
        );

        if (!this.speed || (this.speed < speedPerMinute && !this.isFinished())) {
            this.speed = speedPerMinute;
        }

        return this.speed / 60;
    }
};

PersonalBestBotAlgorithm.prototype.calcBotCoef = function () {
    let coef = this.options.forceCoef;

    if (Array.isArray(coef)) {
        coef = coef.length > 2 ? PseudoRandom.GET().choose(coef) : PseudoRandom.GET().random(coef[0], coef[1]);
    }

    return Math.floor(coef) / 100;
};

PersonalBestBotAlgorithm.SpeedType = {
    PerDay: "per_day",
    PerMinute: "per_minute"
};